<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">Lọc và tìm kiếm</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-field>
                <label>Tìm kiếm theo tên hoặc mã sản phẩm</label>
                <md-input v-model="filter.name"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <md-field>
                <label>Loại rượu</label>
                <md-select v-model="filter.type">
                  <md-option
                    :key="index"
                    v-for="(item, index) in typeSuggestion"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <md-field>
                <label>Nguồn gốc</label>
                <md-select placeholder="Nguồn gốc" v-model="filter.origin">
                  <md-option
                    :key="index"
                    :value="item"
                    v-for="(item, index) in originSuggestion"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <!-- <div
            class="clickable"
            style="display: inline-block;"
            @click="
              listProduct = [];
              pagination.currentPage = 1;
              getData(pagination.perPage * 2)
            "
          >
            <md-icon>filter_alt</md-icon>
            <md-tooltip>Lọc sản phẩm</md-tooltip>
          </div> -->
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">Danh sách sản phẩm</h4>
        </md-card-header>
        <md-card-content>
          <div class="w-full flex-l">
            <md-button @click="goToAccessories" class="md-info mr-10 md-sm">
              Sản phẩm khác
            </md-button>
            <md-button class="md-success mr-10 md-sm" @click="addNewProduct">
              Thêm sản phẩm
            </md-button>
            <md-button
              class="md-success mr-10 md-sm"
              @click="dialogVisible.arrangeItem = true"
            >
              Sắp xếp
            </md-button>
          </div>
          <!-- <div style="width: 200px;">
            <md-field>
              <md-input
                type="search"
                class="mb-3 md-size-20"
                clearable
                style="width: 200px; margin-top: -3vh;"
                placeholder="Tìm kiếm"
                v-model="searchQuery"
              >
              </md-input>
            </md-field>
          </div>-->
          <md-table
            :value="dataFilter"
            class="table-products table-hover"
            table-header-color="green"
            :key="reRenderTable"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              @click="handleEdit(item)"
              class="clickable"
            >
              <md-table-cell
                md-label="Mã sản phẩm"
                class="table-cell"
                align="left"
              >
                {{ item.data.productId }}
              </md-table-cell>
              <md-table-cell md-label="Tên sản phẩm" class="table-cell">
                {{
                  item.data.name.length > 20
                    ? item.data.name.substring(0, 20) + "..."
                    : item.data.name
                }}
                <md-tooltip v-show="item.data.name.length > 20">{{
                  item.data.name
                }}</md-tooltip>
              </md-table-cell>
              <md-table-cell
                md-label="Hình ảnh"
                class="table-cell"
                align="center"
              >
                <div class="image-container">
                  <img :src="item.data.pictureThumbnail" class="box-image" />
                </div>
              </md-table-cell>
              <md-table-cell
                md-label="Nguồn gốc"
                class="table-cell"
                align="left"
              >
                {{ item.data.origin }}
              </md-table-cell>
              <md-table-cell md-label="Loại rượu" class="table-cell">
                {{ item.data.type[0] }}
              </md-table-cell>
              <md-table-cell md-label="Nồng độ" class="table-cell" md-numeric>
                {{ item.data.alcoholPercentage }}
              </md-table-cell>
              <md-table-cell
                md-label="Ẩn/hiện"
                class="table-cell"
                align="center"
              >
                <button
                  class="btnHideShow clickable"
                  v-bind:class="{ btnShow: !item.data.isHide }"
                  @click.stop="hideProduct(item)"
                >
                  {{ item.data.isHide ? "Ẩn" : "Hiện" }}
                </button>
              </md-table-cell>
              <md-table-cell
                md-label="Số lượng"
                class="table-cell"
                md-numeric
                md-sort-by="warehouse"
                >{{
                  item.data.warehouse > 0 ? item.data.warehouse : "Hết hàng"
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Giá bán"
                md-sort-by="price"
                class="table-cell"
                md-numeric
                >{{ formatMoney(item.data.price) }}</md-table-cell
              >
              <md-table-cell class="table-cell" align="center">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.stop="handleDelete(item)"
                  style="margin-right: 5px"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip>Xóa sản phẩm</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Hiển thị từ {{ from + 1 }} đến {{ dataFilter.length }} trong tổng
              số
              {{ total }}
            </p>
          </div>
          <!-- <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination> -->
        </md-card-actions>
      </md-card>
    </div>
    <ArrangeItem
      v-if="dialogVisible.arrangeItem"
      @closeDialog="dialogVisible.arrangeItem = false"
      :showDialog="dialogVisible.arrangeItem"
    />
  </div>
</template>
<script>
import { Pagination } from "@/components";
import DAO from "@/DAO.js";
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import ArrangeItem from "@/components/ArrangeItem";
export default {
  components: { Pagination, ArrangeItem },
  data() {
    return {
      reRenderTable: true,
      currentSort: "price",
      currentSortOrder: "asc",
      suggestion: {
        origin: ["Tất cả"],
        type: ["Tất cả"],
      },
      filter: {
        type: "Tất cả",
        origin: "Tất cả",
        name: "",
      },
      max: 0,
      t: true,
      db: {},
      listProduct: [],
      listProductName: [],
      isAddProduct: false,
      isEditProduct: false,
      idSelected: "",
      searchQuery: "",
      propsToSearch: ["name", "type", "age"],
      searchedData: [],
      fuseSearch: null,
      isDelete: false,
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      dialogVisible: {
        arrangeItem: false,
      },
    };
  },
  created() {
    this.db = firebase.firestore();
    this.$store.dispatch("FLAG_LOADING", true);
    this.listProduct = [...this.$listProducts];
    this.pagination.currentPage = Number(this.$route.query.page) || 1;
    this.filter.name = this.$route.query.search || "";
    this.filter.origin = this.$route.query.origin || "Tất cả";
    this.filter.type = this.$route.query.type || "Tất cả";
    this.db
      .collection(process.env.VUE_APP_SUGGESTION_LIST)
      .doc("Products")
      .get()
      .then((docRef) => {
        if (docRef.exists) {
          this.suggestion.origin = ["Tất cả", ...docRef.data().origin];
          this.suggestion.type = ["Tất cả", ...docRef.data().wineType];
        }
      })
      .catch((error) => console.log(error));
    let bits = localStorage.getItem("bits");
    // let reg = /\w*V[^O]/g         //This regex is inconsistent, don't know why
    this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_WINE + bits)
      .get()
      .then((docRef) => {
        let arr = [];
        if (docRef.exists) {
          docRef.data().listWine.forEach((item) => {
            if (item.productId[0] == "V" && item.productId[1] != "O") {
              this.listProductName.push(item.name);
            }
          });
          this.$store.dispatch("FLAG_LOADING", false);
        } else this.$store.dispatch("FLAG_LOADING", false);
      })
      .catch((error) => {
        console.log(error);
        this.$store.dispatch("FLAG_LOADING", false);
      });
  },
  watch: {
    $listProducts: function (newVal, oldVal) {
      this.listProduct = JSON.parse(JSON.stringify(this.$listProducts));
    },
    "pagination.currentPage": function () {
      this.$router.replace({
        path: "manage-products",
        query: {
          page: this.pagination.currentPage,
          search: this.filter.name,
          origin: this.filter.origin,
          type: this.filter.type,
        },
      });
    },
    "filter.name": function () {
      this.$router.replace({
        path: "manage-products",
        query: {
          page: this.pagination.currentPage,
          search: this.filter.name,
          origin: this.filter.origin,
          type: this.filter.type,
        },
      });
    },
    "filter.origin": function () {
      this.$router.replace({
        path: "manage-products",
        query: {
          page: this.pagination.currentPage,
          search: this.filter.name,
          origin: this.filter.origin,
          type: this.filter.type,
        },
      });
    },
    "filter.type": function () {
      this.$router.replace({
        path: "manage-products",
        query: {
          page: this.pagination.currentPage,
          search: this.filter.name,
          origin: this.filter.origin,
          type: this.filter.type,
        },
      });
    },
  },
  computed: {
    ...mapGetters(["$listProducts"]),
    originSuggestion() {
      return Array.from(
        new Set(this.listProduct.map((item) => item.data.origin))
      ).concat(["Tất cả"]);
    },
    typeSuggestion() {
      return Array.from(
        new Set(this.listProduct.map((item) => item.data.type[0]))
      ).concat(["Tất cả"]);
    },
    dataFilter() {
      var result = JSON.parse(JSON.stringify(this.listProduct));
      if (this.filter.name !== "") {
        result = result.filter(
          (item) =>
            item.data.name
              .toLowerCase()
              .indexOf(this.filter.name.toLowerCase()) !== -1 ||
            item.data.productId
              .toLowerCase()
              .indexOf(this.filter.name.toLowerCase()) !== -1
        );
      }
      if (this.filter.origin != "Tất cả") {
        result = result.filter(
          (item) => item.data.origin === this.filter.origin
        );
      }
      if (this.filter.type != "Tất cả") {
        result = result.filter((item) =>
          item.data.type.includes(this.filter.type)
        );
      }
      return result;
    },
    queriedData() {
      return this.dataFilter.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.dataFilter.length;
    },
  },

  methods: {
    getData(limit) {
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      let query = this.db.collection(process.env.VUE_APP_WINE + bits);
      if (this.filter.origin !== "Tất cả" && this.filter.name === "") {
        query = query.where("origin", "==", this.filter.origin);
      }
      if (this.filter.type !== "Tất cả" && this.filter.name === "") {
        query = query.where("type", "array-contains", this.filter.type);
      } else query = query.where("tags", "array-contains", "Rượu");
      if (this.filter.name !== "") {
        query = query.where("name", "==", this.filter.name);
      }
      query = query
        .where(
          "name",
          ">",
          this.listProduct[this.listProduct.length - 1]
            ? this.listProduct[this.listProduct.length - 1].data.name
            : ""
        )
        .limit(limit)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.listProduct.push({
              id: item.id,
              data: item.data(),
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          console.log(error);
          this.dispatch("FLAG_LOADING", false);
        });
    },
    previusPage() {
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage--;
      }
    },
    async nextPage() {
      if (
        this.queriedData[this.queriedData.length - 1] ===
          this.listProduct[
            this.listProduct.length - this.pagination.perPage - 1
          ] &&
        this.queriedData.length === this.pagination.perPage
      ) {
        this.pagination.currentPage++;
        await this.getData(this.pagination.perPage);
      } else if (
        this.queriedData[this.queriedData.length - 1] !==
        this.listProduct[this.listProduct.length - 1]
      )
        this.pagination.currentPage++;
    },
    goToAccessories() {
      this.$router.push({ name: "Phụ kiện rượu vang" });
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          if (
            this.currentSort === "price" ||
            this.currentSort === "warehouse"
          ) {
            if (a.data[sortBy] != null && b.data[sortBy] != null) {
              return -parseInt(a.data[sortBy]) + parseInt(b.data[sortBy]);
            } else if (a.data[sortBy] != null) {
              return -1;
            } else if (b.data[sortBy] != null) {
              return 1;
            } else {
              return 0;
            }
          } else return a.data[sortBy].localeCompare(b.data[sortBy]);
        }
        if (this.currentSort === "price" || this.currentSort === "warehouse") {
          if (a.data[sortBy] != null && b.data[sortBy] != null) {
            return parseInt(a.data[sortBy]) - parseInt(b.data[sortBy]);
          } else if (a.data[sortBy] != null) {
            return 1;
          } else if (b.data[sortBy] != null) {
            return -1;
          } else {
            return 0;
          }
        } else return b.data[sortBy].localeCompare(a.data[sortBy]);
      });
    },
    addNewProduct() {
      this.$router.push({ name: "Sản phẩm" });
    },
    hideProduct(item) {
      this.$store.dispatch("FLAG_LOADING", true);
      this.reRenderTable = !this.reRenderTable;
      item.data.isHide = !item.data.isHide;
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_WINE + bits)
        .doc(item.id)
        .update(item.data)
        .then((res) => {
          this.$store.commit("EDIT_PRODUCT", item.id);
          this.$store.dispatch("FLAG_LOADING", false);
        });
    },
    handleDelete(item) {
      this.isDelete = true;
      Swal.fire({
        title: "Xóa sản phẩm",
        text: `Sản phẩm sẽ bị xóa khỏi danh sách`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isDelete = false;
          this.$store.dispatch("FLAG_LOADING", true);
          let bits = localStorage.getItem("bits");
          DAO.deleteDocumentInFireStore(
            this.db,
            process.env.VUE_APP_WINE + bits,
            item.id
          )
            .then(() => {
              this.$messageSuccess("Xóa sản phẩm thành công");
              this.$store.commit("DELETE_PRODUCT", item);
              this.$store.dispatch("FLAG_LOADING", false);
            })
            .catch((error) => {
              this.$messageError("Không xóa được sản phẩm, xin thử lại");
              this.$store.dispatch("FLAG_LOADING", false);
            });
        } else this.isDelete = false;
      });
    },
    handleEdit(item) {
      if (!this.isDelete && item) {
        this.$router.push({ name: "Sản phẩm", query: { id: item.id } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tableFooter {
  padding: 10px !important;
}

.button-add {
  position: absolute;
  z-index: 1;
  top: 2vh;
  right: 2vh;
}
.img-product {
  height: 7vh;
  width: auto;
}

.btn-refresh {
  position: fixed;
  z-index: 2;
  bottom: 10vh;
}
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
.btnHideShow {
  border: none;
  background: rgb(122, 122, 122);
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
  color: white;
}
.btnShow {
  background: cadetblue;
}
.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}
</style>
